"use client";
import React from 'react';
import CommentCardComponentMobile from "@/components/ui/comments/comment-card-component-mobile";
import {ChevronLeft, MessageSquareMoreIcon, MoveRight, SortDesc, Star} from "lucide-react";
import {SingleProductEnum} from "@/constants/commerce-enum";
import {Button} from "@/components/ui/button";
import AddNewComment from "@/components/ui/add-new-comment/add-new-comment";

interface IProps {
    sortedComments: any[];
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    showFilters: boolean;
    setShowFilters: (showFilters: boolean) => void;
    isAddCommentOpen: boolean;
    setIsAddCommentOpen: (showFilters: boolean) => void;
    dropdownRef: any;
    handleSort: (order: 'newest' | 'oldest') => void;
    data: any
}

const MobileCommentsContainers: React.FC<IProps> = ({
                                                        sortedComments,
                                                        setIsOpen, isOpen,
                                                        showFilters, setShowFilters,
                                                        dropdownRef, handleSort, data,
                                                        isAddCommentOpen, setIsAddCommentOpen,
                                                    }) => {
    return (
        <section className="w-full flex gap-4 overflow-x-auto items-center mt-5">
            {sortedComments.length > 0 ? (
                <>
                    {sortedComments.slice(0, 4).map((item: any, index: number) => (
                        <React.Fragment key={index}>
                            <CommentCardComponentMobile
                                drawer={true}
                                content={item?.content}
                                rate={item?.rate}
                                date={item?.created_at}
                                username={`${item?.creator?.first_name} ${item?.creator?.last_name}`}
                                id={item?.id}
                                likesCount={item?.likes_count}
                                dislikesCount={item?.dislikes_count}
                            />
                        </React.Fragment>
                    ))}
                    <div
                        onClick={() => setIsOpen(true)}
                        className={`h-full flex items-center justify-center text-blue-secondary flex-wrap gap-y-4 ${sortedComments.length < 5 && " hidden"}`}
                    >
                        <div
                            className="w-[42px] h-[42px] flex flex-wrap items-center justify-center rounded-xl border border-blue-secondary">
                            <ChevronLeft className={"h-7 w-7"}/>
                        </div>
                        <div className="text-xs text-nowrap">
                            {SingleProductEnum.viewAll}
                        </div>
                    </div>
                    {isOpen && (
                        <div className="w-screen h-screen bg-white fixed !z-[100] top-0 left-0 pb-24 p-[23px]">
                            <div className="w-full flex items-center justify-between">
                                <div className="flex items-center gap-2 font-bold ">
                                    <MoveRight className="h-6 w-6" onClick={() => setIsOpen(false)}/>
                                    {SingleProductEnum.allComments}
                                </div>
                                <div
                                    className="flex items-center gap-2 font-bold z-[999]"
                                    onClick={() => {
                                        setShowFilters(!showFilters);
                                        console.log("showFilters", !showFilters);
                                    }}
                                >
                                    <SortDesc className="h-6 w-6"/>
                                    {SingleProductEnum.filter}
                                </div>
                                {showFilters && (
                                    <div
                                        ref={dropdownRef}
                                        className={"fixed top-12 left-4 p-4 bg-white w-[90px] rounded-lg transition-all"}
                                        style={{boxShadow: "1px 4px 12px 0px rgba(0, 0, 0, 0.04)"}}>
                                        <ul className={"flex flex-col gap-1"}>
                                            <li className={"text-xs"} onClick={() => handleSort('newest')}>
                                                <Button variant={"link"}
                                                        className={"p-0"}> {SingleProductEnum.newest}</Button>
                                            </li>
                                            <li className={"text-xs"} onClick={() => handleSort('oldest')}>
                                                <Button variant={"link"} className={"p-0"}>
                                                    {SingleProductEnum.oldest}
                                                </Button>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                            <section
                                className='w-full flex  overflow-y-auto pb-12 flex-wrap mt-7 mb-5 font-bold items-center'>
                                <div className={"flex items-center justify-between w-full"}>
                                    <div className="w-1/2 flex  gap-2 flex-wrap items-center">
                                        <h6>
                                            {SingleProductEnum.usersComments}
                                        </h6>
                                        <div className="text-xs text-gray-400">
                                            ({sortedComments.length.toLocaleString("fa")})
                                        </div>
                                    </div>
                                    <div className="w-1/2 items-center justify-end gap-2 flex ">
                                        <div className="text-black font-medium gap-1 flex items-center ">
                                                <span>
                                                    {data?.data?.product?.rate_average?.toLocaleString("fa") ?? 0}
                                                </span>
                                            <span className="font-extralight text-sm text-gray-400">
                                                    {SingleProductEnum.from}
                                                </span>
                                            <span className={"text-sm text-gray-400"}>
                                                    ۵
                                                </span>
                                        </div>
                                        <Star className="w-5 h-5 text-yellow-400 fill-yellow-400"/>
                                    </div>
                                </div>
                                <div className="w-full flex flex-wrap gap-y-4 mt-6 ">
                                    {sortedComments.map((item: any, index) => (
                                        <React.Fragment key={index}>
                                            <CommentCardComponentMobile
                                                drawer={false}
                                                className={"w-full"}
                                                content={item?.content}
                                                rate={item?.rate}
                                                date={item?.created_at}
                                                username={`${item?.creator?.first_name} ${item?.creator?.last_name}`}
                                                id={item?.id}
                                                likesCount={item?.likes_count}
                                                dislikesCount={item?.dislikes_count}
                                            />
                                        </React.Fragment>
                                    ))}
                                </div>
                                <div
                                    className={"h-[86px] border fixed bottom-0 left-0 bg-white px-[23px] w-full flex flex-wrap items-center justify-center"}>
                                    <AddNewComment
                                        id={data?.data?.product?.id}
                                        title={data?.data?.product?.title}
                                        isOpen={isAddCommentOpen}
                                        onOpenChange={setIsAddCommentOpen}
                                        onCloseFirstModal={() => setIsOpen(false)}
                                    />
                                </div>
                            </section>
                        </div>
                    )}
                </>
            ) : (
                <div className="w-full flex flex-wrap h-[200px] items-center justify-center">
                    <MessageSquareMoreIcon strokeWidth={1} className="h-20 w-20 text-blue-secondary/90"/>
                    <div
                        className="w-full flex items-center justify-center text-blue-secondary font-extralight">
                        {SingleProductEnum.beFirstComment}
                    </div>
                </div>
            )}
        </section>
    );
};

export default MobileCommentsContainers;